import { EmployeeRole } from '@/api/apis/resources';
import { Uuid } from '@/api/types';
import { ResourceWarning, WarningType } from '../types';

export const createPrimaryWarningHandler = (toggleWarning: (warning: ResourceWarning) => void) => {
  return (employeeId: Uuid, employeeFullName: string | null, employeeRole: EmployeeRole) => {
    const message = `${employeeFullName || ''} who was marked as the Primary, has been detached from the case. The system will suggest a new Primary, and you'll be able to update the selection if needed.`;

    const warning: ResourceWarning = {
      id: `${employeeId}:${employeeRole}:primary`,
      type: WarningType.Primary,
      employeeId,
      role: employeeRole,
      message,
    };

    toggleWarning(warning);
  };
};
